import { Box, Divider, Typography } from '@mui/material'
import { PATH_ROOT } from 'constants/api'
import useLoginSSO from 'hooks/useLoginSSO'
import MyCustomButton from 'pages/authentication/login/MyCustomButton'
import useSMEIAM from 'pages/authentication/useSMEIAM'
import useViettelCloudIAM from 'pages/authentication/useViettelCloudIAM'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { NavLink, useSearchParams } from 'react-router-dom'

const OtherLogin = ({ isLogin }) => {
    const { t } = useTranslation()
    const { loginSSOGoogle } = useLoginSSO()
    const { login: loginViettelCloud } = useViettelCloudIAM()
    const { login: loginSME } = useSMEIAM()
    const [params] = useSearchParams();

    const infoLogin = {
        descAccount: 'auth.noAccount',
        descNavigate: 'auth.registerLink',
        path: params.get('domain') ? `${PATH_ROOT}/auth/register?domain=${params.get('domain')}` : `${PATH_ROOT}/auth/register`
    }

    const infoRegister = {
        descAccount: 'auth.alreadyAccount',
        descNavigate: 'auth.login',
        path: params.get('domain') ? `${PATH_ROOT}/auth/login?domain=${params.get('domain')}` : `${PATH_ROOT}/auth/login`
    }

    const info = isLogin ? infoLogin : infoRegister

    return (
        <Box sx={{ marginTop: '1.25rem' }}>
            <Divider sx={{ width: '100%', mb: 1 }}>
                <Typography px={2} sx={{ color: theme => theme.palette.text.secondary }}>{t('auth.or')}</Typography>
            </Divider>
            <MyCustomButton login_sso_google={loginSSOGoogle}
                loginSME={loginSME}
                loginViettelCloud={loginViettelCloud}
            />
            <Box display={'flex'} justifyContent={'space-between'} mt={2.5}>
                <Typography>{t(info.descAccount)}</Typography>
                <NavLink className={"text-link"} to={info.path}>
                    {t(info.descNavigate)}
                </NavLink>
            </Box>
        </Box>
    )
}

export default OtherLogin